module.exports = __webpack_public_path__ + "img/avatar-61.5145ee37.png";